import { StatusType } from 'common/api/resources/statuses';
export default StatusType;
